import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'filteroptions',
  standalone: false  //NOSONAR
})
export class FilteroptionsPipe implements PipeTransform {
  transform(value: any, ...args: any[]): any {
    if (value.includes(',')) {
      return value.split(',');
    }
    // value = camelCase(value);
    const _value = args[0].get(value)?.value;
    if (!_value) {
      return [];
    }
    if (typeof _value === 'string') {
      const val = JSON.parse(_value);
      return val?.values || [];
    } else if (_value === 'object') {
      return _value?.values || [];
    }
    return [];
  }
}
